import { Box, Typography } from "@braintrust/braintrust-ui-components";

import { JobBidCommentList } from "../bid-comment-list";

type ExpandedItemProps = {
  id: number;
};

export const ExpandedItem = ({ ...props }: ExpandedItemProps) => {
  return (
    <Box
      data-testid="expanded-bid-item"
      sx={{ px: "var(--px)", maxWidth: "1120px", display: "grid", mb: 1.5 }}
    >
      <Typography
        component="p"
        variant="label"
        fontWeight={500}
        color="grey-1"
        size="small"
        sx={{ marginBottom: "8px" }}
      >
        Talent can't see comments.
      </Typography>
      <JobBidCommentList {...props} />
    </Box>
  );
};
